export default __webpack_public_path__ + "static/media/locker.34203804.svg";